/* src/app/pages/logout/logout.component.scss */
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
}
.container {
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
/*# sourceMappingURL=logout.component.css.map */
